export { signage } from './signage';
export { dashboard } from './dashboard';
export { checkin, formFieldSchema } from './checkin';
export type { PresetDefinition } from './types';
export { presetConfigFields } from './config-fields';
export type { PresetConfigField, PresetFieldType } from './config-fields';
export { PRESET_CONFIG_CONTROLS, PresetConfigControlSchema } from './controls';
export type { PresetConfigControl } from './controls';

import { checkin } from './checkin';
import { dashboard } from './dashboard';
import { signage } from './signage';

export const PRESETS = [signage, dashboard, checkin] as const;
